import { readPriceQuoteResult } from './price-quote-result';

export const generatedPriceQuoteFields = {
    priceQuoteResult: {
        read: readPriceQuoteResult,
    },
};
